import { ApolloProvider, InMemoryCache } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';
import React, { StrictMode } from 'react';
import { render } from 'react-dom';
import { Route, Routes } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { createApolloClientWithCache } from '../_shared/apolloClientUtils';
import SearchPageContainer from './components/SearchPageContainer';
import PlpProvider from '../product-listing-page/PLPContext';
import { ExplicitDeadEnd } from 'src/scripts/utils/react/ErrorBoundary';

const plpCache = new InMemoryCache({
  typePolicies: {
    Collection: {
      fields: {
        products: relayStylePagination(['sortKey', 'reverse']),
      },
    },
    Query: {
      fields: {
        products: relayStylePagination(['sortKey', 'reverse', 'query']),
      },
    },
  },
});

const client = createApolloClientWithCache(plpCache);

const Wrapper = () => {
  return (
    <StrictMode>
      <PlpProvider>
        <ApolloProvider client={client}>
          <BrowserRouter>
            <Routes>
              <Route path="/:shopifyRoot/search/*" element={<SearchPageContainer />} />
              <Route path="/search/*" element={<SearchPageContainer />} />
              <Route path="*" element={<ExplicitDeadEnd />} />
            </Routes>
          </BrowserRouter>
        </ApolloProvider>
      </PlpProvider>
    </StrictMode>
  );
};

render(<Wrapper />, document.querySelector('[react-render-target="search-page"]'));
